<div class="dashboard heisenberg-background">
    <div class='content'>
        <h1>Magalies Pharma Prescriptions</h1>
        <a *ngIf ="!currentUser"  routerLink="/portal" mat-raised-button color='primary'>
            <mat-icon>lock_open</mat-icon> Sign In
        </a>
        <a *ngIf ="currentUser" routerLink="/portal/submit" mat-raised-button color="primary">
            <mat-icon>add</mat-icon> New prescription
        </a>
    </div>
</div>